import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  containerDark: {
    backgroundColor: theme.colors.card_background_secondary,
    padding: theme.spacing(8, 6),
    borderRadius: theme.sizes.roundCorners,
    ...reskinStyles(theme, theme.cardStyles.outlined)
  },
  table: {
    '& td, th': {
      borderBottom: 'none',
      padding: theme.spacing(4),
      whiteSpace: 'nowrap'
    },
    '& td:last-child': {
      paddingRight: theme.spacing(7)
    },
    '& tr': {
      borderBottom: `1px solid ${theme.onCardDivider.beige_25_op_30}`
    }
  },
  columnLabel: {
    color: theme.colors.light_text,
    opacity: 0.6
  }
});

export default makeStyles(styles);
